import { Button, Col, Form, Input, Modal, Row, Select, message } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cerrarSesion } from "../../redux/actions/sesion";
import { urlapi } from "../../lib/backend/data";
import { PlusCircleFilled } from "@ant-design/icons";
import CamposObligatoriosLeyenda from "../../subComponents/general/formularios/campos_obligatorios";
import { tipos_campos_personalizados, tipos_ingreso } from "./data";
import Paragraph from "antd/es/typography/Paragraph";
import { MdKeyboardArrowRight } from 'react-icons/md'
import { AiFillMinusCircle, AiOutlinePlus } from "react-icons/ai";
import { estilo_moving_truck } from "../../lib/estilo_sitio";

const CrearNuevoCampoPersonalizado = (props) => {
    const [ campo, setCampo ] = useState({})
    const pais = useSelector(state => state.pais)
    const idioma = useSelector(state => state.idioma)
    const session = useSelector(state => state.miusuario)
    const [ opcion, setOpcion ] = useState('')
    const [messageApi, contextHolder] = message.useMessage();
    const [ loading, setLoading ] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch()

    const opcionesInvalids = () => {
        return messageApi.error("Opciones inválidas para tipo de selección")
    }

    const crearCampo = async () => {
        if(!campo.tipo) return messageApi.error("Tipo no válido")
        if(!campo.title) return messageApi.error("Escribe un título")
        if(campo.title.length < 3) return messageApi.error("Escribe un título válido")


        if(campo.tipo_ingreso === "seleccion"){
            if(!campo.opciones) return opcionesInvalids()
            if(campo.opciones.length < 1) return opcionesInvalids()
            const filter = campo.opciones.filter(e => !e.value)
            if(filter.length > 0) return opcionesInvalids()
        }


        setLoading(true)
        return fetch(`${urlapi}/campos-personalizados`,{
            method:'POST',
            body: JSON.stringify(campo),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`,
                'country': pais,
                'lang': idioma
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
                return setLoading(false)
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
                return setLoading(false)
            } else if(res._id){
                messageApi.success("Creado exitosamente")
                setIsModalOpen(false)
                setCampo({...{}, ...{}})
                if(props.onCreate) props.onCreate()
            }
            return setLoading(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }

    const showModal = () => {
      setIsModalOpen(true);
    };

    const handleOk = () => {
        return crearCampo()
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        return setCampo({...{}, ...{}})
      };

    const handleChange = (e) => {
        const { name, value } = e.target
        return setCampo(prev => {
            let actual = {...prev}
            actual[name] = value
            return {...{}, ...actual}
        })
    }


    const handleChangeSelect = (name, value) => {
        campo[name] = value
        return setCampo({...{}, ...campo})
    }

    const handleChangeOpcion = (e,pos) => {
        return setCampo(prev => {
            let actual = {...prev}
            actual.opciones[pos].value = e.target.value
            return {...{}, ...actual}
        })
    }

    const eliminarOpcion = (i) => {
        return setCampo(prev => {
            const actual = {...prev}
            actual.opciones.splice(i,1)
            return {...{}, ...campo}
        })
    }

    const mostrarOpciones = () => {
        if(!campo.opciones) return false
        return <div style={{ marginTop: 15 }}>
            {
                campo.opciones.map((opcio,ip) => {
                    return <div key={`op-${ip}`}>
                        <Row>
                            <Col xs={2}><AiFillMinusCircle className="hover"  onClick={() => eliminarOpcion(ip)} size={30} color={estilo_moving_truck.colors.danger} /></Col>
                            <Col xs={22}>
                                <Form.Item required>
                                    <Input style={{ width: "100%" }} value={opcio.value} onChange={(e) => handleChangeOpcion(e,ip)} />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                    </div>
                })
            }
        </div>
    }

    const agregarValor = () => {
        return setCampo(prev => {
            let actual = {...prev}
            if(!actual.opciones) actual.opciones = []
            actual.opciones.unshift({
                value: ""
            })
            return {...{}, ...actual}
        })
    }

    const opcionesBox = () => {
        if(!campo) return false
        if(campo.tipo_ingreso !== "seleccion") return false
        return <div style={{ marginTop: 15 }}>
            <Button size="small" onClick={() => agregarValor()}><AiOutlinePlus style={{ verticalAlign: "middle" }} /> AGREGAR NUEVO VALOR</Button>
            {mostrarOpciones()}
        </div>
    }
    
    return <div>
        <Button className="mb-3" type="primary" size="small" onClick={showModal}><PlusCircleFilled /> CREAR NUEVO</Button>
        <Modal 
            title="Crear nuevo campo personalizado" 
            open={isModalOpen} 
            onOk={handleOk} 
            onCancel={handleCancel}
            confirmLoading={loading}
        >
            <CamposObligatoriosLeyenda />
            <Form layout="vertical">
                <Form.Item label="Tipo" className="mb-2" required>
                    <Select
                    options={tipos_campos_personalizados}
                    onChange={(e) => handleChangeSelect('tipo',e)} 
                    />
                </Form.Item>
                <Form.Item label="Nombre" className="mb-2" required>
                    <Input name="title" value={campo.title} onChange={handleChange} />
                </Form.Item>
                <Form.Item label="Tipo de ingreso" className="mb-2" required>
                    <Select
                    options={tipos_ingreso}
                    defaultValue=""
                    onChange={(e) => handleChangeSelect('tipo_ingreso',e)} 
                    />
                </Form.Item>
            </Form>
            {opcionesBox()}
      </Modal>
      {contextHolder}
    </div>
}

export default CrearNuevoCampoPersonalizado